import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Dropdown } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import RenewalHistoryCard from "../../components/Cards/RenewalHistoryCard.js";
import AccountPlanCard from "../Cards/AccountPlanCard.js";
import PaymentMtdCard from "../Cards/PaymentMtdCard.js";
import Modal from "react-bootstrap/Modal";
import UserService from "../../services/user.service";
import moment from "moment";
import ToastBlockContainer from "../../common/ToastBlockContainer";
import { Primary } from "../../stories/Button.stories.js";
import CheckoutForm from "./CheckoutForm.js";

const ManageSubscription = (props) => {
  let history = useHistory();
  const startingYear = 2022;
  const currentYear = moment(new Date()).format("YYYY");
  const [showPaymentMtd, setShowPaymentMtd] = useState(false);
  const [familyDetails, setFamilyDetails] = useState([]);
  const [currentPlanDetails, setCurrentPlanDetails] = useState([]);
  const [custId, setCustId] = useState();
  const [paymentList, setPaymentList] = useState([]);
  const [activePaymentMethod, setActivePaymentMethod] = useState({ card: "" });
  const [paymentMethodLoading, setPaymentMethodLoading] = useState(true);
  const [currentPlanLoader, setCurrentPlanLoader] = useState(true);
  const [invoiceListingLoader, setInvoiceListingLoader] = useState(true);
  const [showAddNewPaymentMethod, setShowAddNewPaymentMethod] = useState(false);
  const [invoiceList, setInvoiceList] = useState([]);
  const [yearsList, setYearsList] = useState([]);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [newYear, setNewYear] = useState(currentYear);
  const [showToast, setShowToast] = useState(false);
  const [successToast, setSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [checkYear, setcheckYear] = useState("");
  const [showCancelAccount, setShowCancelAccount] = useState(false);
  const [showTrialPopup, setShowTrialPopup] = useState(false);
  const [trialCheck, settrialCheck] = useState({});
  const [trialCheck1, settrialCheck1] = useState({});
  const [cancelReason, setcancelReason] = useState(false);
  const [canceledDate, setcanceledDate] = useState("");
  const [cancelDate, setcancelDate] = useState("");
  var UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
  let { uuid } = useParams();

  let savedCardNo = localStorage.getItem("hello");

  useEffect(() => {
    window.addEventListener("mouseup", function (event) {
      var modalCardVal = document.getElementById("modalCardVal");
      if (
        event.target !== modalCardVal &&
        event.target.parentNode !== modalCardVal
      ) {
        setValueClick("");
      }
    });
  });

  useEffect(() => {
    setUpYearsList();

    // get family details
    UserService.getUserSingleFamilyDetails(uuid, UserDetails.id).then(
      (response) => {
        console.log(response?.FamilyData?.Family?.Family_Subscription);
        setFamilyDetails(response);
        setCustId(response?.FamilyData?.Family?.stripeCustomerId);
        setCurrentPlanDetails(
          response?.FamilyData?.Family?.Family_Subscription
            ?.Account_Subscription_Plan
        );
        let st = new Date("01-01-" + currentYear).getTime();

        const stripeSubId = response?.FamilyData?.Family?.Family_Subscription?.stripeSubscriptionId;
        if (stripeSubId) {
          getCustomerStripeInvoiceList(
            response?.FamilyData?.Family?.stripeCustomerId,
            stripeSubId,
            st
          );
        }

        // update DB stripe API called
        let payLoad = {
          stripeSubscriptionId: stripeSubId,
          FamilyId: response?.FamilyData?.FamilyId,
          AccountSubscriptionPlanId:
            response?.FamilyData?.Family?.Family_Subscription
              ?.Account_Subscription_Plan?.id,
        };
        UserService.updateDBwithStripe(payLoad).then(
          (value) => {
            console.log(value);

            const subscriptionObject = value?.data?.[1]?.subscriptionObject;
            const dbSubscriptionObject = response?.FamilyData?.Family?.Family_Subscription?.subscriptionObject;

            setActivePaymentMethod(
              subscriptionObject?.cardDetails
            );

            settrialCheck(subscriptionObject || {});

            if (subscriptionObject?.items?.data && dbSubscriptionObject?.items?.data) {
              settrialCheck1(
                subscriptionObject.items.data[
                  dbSubscriptionObject.items.data.length - 1
                ] || {}
              );
            } else if (subscriptionObject?.items?.data?.[0]) {
              settrialCheck1(subscriptionObject.items.data[0]);
            } else {
              settrialCheck1({});
            }

            //cancelled Date
            if (subscriptionObject?.canceled_at) {
              var dateCancelled = new Date(
                subscriptionObject.canceled_at * 1000
              );
              const momentCancelled = moment(dateCancelled).format(
                "MMMM Do, YYYY"
              );
              setcanceledDate(momentCancelled);
            }

            //stripe cancelled date
            if (subscriptionObject?.current_period_end) {
              var dateCancelFt = new Date(
                subscriptionObject.current_period_end * 1000
              );
              const momentCancel = moment(dateCancelFt).format("MMMM Do, YYYY");
              setcancelDate(momentCancel);
            }
            setTimeout(() => {
              setCurrentPlanLoader(false);
              setPaymentMethodLoading(false);
            }, 500);
          },
          (error) => {}
        );
      },
      (error) => {}
    );
  }, []);

  const getCustomerStripeInvoiceList = (custId, subscription, startDate) => {
    UserService.getCustomerInvoiceList(custId, subscription, startDate).then(
      (res) => {
        var items = [];

        if (res.length > 0) {
          for (let i = 0; i < res.length; i++) {
            items.push({
              payment_date: moment.unix(res[i].created).format("MMMM Do, YYYY"),
              currency: res[i].currency === "gbp" ? "£" : res[i].currency,
              amount:
                String(res[i].amount_paid).slice(0, -2) +
                "." +
                String(res[i].amount_paid).slice(-2),
              inv_number: res[i].number,
              billing_reason: res[i].billing_reason,
              file: res[i].invoice_pdf,
              currYear: moment.unix(res[i].created).format("YYYY"),
              hostURL: res[i].hosted_invoice_url,
              renewalType: res[i].lines.data[0].plan.interval,
            });

            if (Number(i) + 1 === res.length) {
              setInvoiceList(items);
              setInvoiceListingLoader(false);
            }
          }
        } else {
          setInvoiceList([]);
          setInvoiceListingLoader(false);
        }
      }
    );
  };

  const setUpYearsList = () => {
    let items = [];
    for (let i = startingYear; i <= currentYear; i++) {
      items.push({ value: i });
      if (Number(i) === Number(currentYear)) {
        setYearsList(items);
      }
    }
  };

  const handleYearSelect = (e) => {
    setNewYear(e);
    if (e !== selectedYear) {
      setInvoiceListingLoader(true);
      setInvoiceList([]);
      setSelectedYear(e);
      let st = new Date("01-01-" + e).getTime();
      getCustomerStripeInvoiceList(
        custId,
        familyDetails.FamilyData.Family.Family_Subscription
          .stripeSubscriptionId,
        st
      );
    }
  };

  const [cardNo, setCardNo] = useState([]);

  useEffect(() => {
    var newData = [savedCardNo];
    for (var i = 0; i < paymentList.length; i++) {
      newData.push(paymentList[i].card.last4);
    }
    setCardNo(newData);
  }, [paymentList]);

  const [valueClick, setValueClick] = useState("");
  useEffect(() => {
    for (let i = 0; i < invoiceList.length; i++) {
      if (invoiceList[i].currYear !== newYear) {
        setcheckYear("checkYear");
      } else {
        setcheckYear("");
      }
    }
  }, [handleYearSelect]);

  const handleChildData = () => {
    var createDate = trialCheck.created;
    var endDate = trialCheck.trial_end;

    if (endDate !== null) {
      var differenceTime = endDate - createDate;
    }
    if (endDate) {
      if (differenceTime <= 2592000) {
        setShowTrialPopup(true);
      } else {
        setShowCancelAccount(true);
      }
    } else {
      setShowCancelAccount(true);
    }
  };

  const handleCloseCancelAccount = (e) => {
    setShowCancelAccount(false);
  };

  const handleCloseTrialPopup = (e) => {
    setShowTrialPopup(false);
  };

  const cancelFamily = (e) => {
    setcancelReason(true);
    setShowTrialPopup(false);
    setShowCancelAccount(false);
  };

  const cancelFamilyHide = (e) => {
    setcancelReason(false);
  };

  const cancelFamilyTrial = (e) => {
    const unixTimestamp = trialCheck.created + 60 * 24 * 60 * 60; // 60days
    // const unixTimestamp = trialCheck.created + 30 * 60;

    let subsciptionData = {
      trial_end: unixTimestamp,
      proration_behavior: "always_invoice",
      "items[0][plan]": trialCheck.plan.id,
      "items[0][id]": trialCheck1.id,
    };
    UserService.updateSubsciptionStripe(subsciptionData, trialCheck.id).then(
      (response) => {
        if (response.status !== 400 && response.status !== 404) {
          setShowToast(true);
          setSuccessToast(true);
          setToastMessage(
            "Subscription extended for the next 30 days successfully"
          );
          setTimeout(() => {
            history.push({
              pathname: `/dashboard/${uuid}`,
            });
          }, 3000);
        }
      }
    );
  };

  const [textAreaField, settextAreaField] = useState("");
  const textField = (e) => {
    settextAreaField(e.target.value);
  };

  const cancelFamilySuccessfully = (e) => {
    // add reason for cancellation
    let dataValue = {
      cancellationComments: textAreaField,
    };

    UserService.reasonCancelFamily(uuid, dataValue).then((respo) => {});

    //cancel the family

    if (trialCheck.status === "trialing") {
      UserService.cancelSubscriptionStripe(trialCheck.id).then((respo) => {
        if (respo.status !== 400 && respo.status !== 404) {
          setShowToast(true);
          setSuccessToast(true);
          setToastMessage("Subscription cancelled successfully");
          setTimeout(() => {
            history.push("/family_selection");
          }, 3000);
        }
      });
    } else {
      UserService.getSubsciptionStripe(trialCheck.id).then((respo) => {
        let subscriptionDate = {
          from_subscription: respo.id,
        };
        UserService.createSubsciptionScheduleStripe(subscriptionDate).then(
          (resp) => {
            if (resp.status === 400) {
              let subsched = resp.data.error.message
                .split(":")[1]
                .trim()
                .slice(1, -2);
              let cancelObj = {
                end_behavior: "cancel",
              };
              UserService.updateSubsciptionScheduleStripe(
                cancelObj,
                subsched
              ).then(
                (response) => {
                  if (response.status !== 400 && response.status !== 404) {
                    setShowToast(true);
                    setSuccessToast(true);
                    setToastMessage("Subscription cancelled successfully");
                    setTimeout(() => {
                      history.push("/family_selection");
                    }, 3000);
                  }
                },
                (error) => {}
              );
            } else {
              let cancelObj = {
                end_behavior: "cancel",
              };
              UserService.updateSubsciptionScheduleStripe(
                cancelObj,
                resp.id
              ).then(
                (response) => {
                  if (response.status !== 400 && response.status !== 404) {
                    setShowToast(true);
                    setSuccessToast(true);
                    setToastMessage("Subscription cancelled successfully");
                    setTimeout(() => {
                      history.push("/family_selection");
                    }, 3000);
                  }
                },
                (error) => {}
              );
            }
          }
        );
      });
    }
  };

  const backToFD = () => {
    history.push(`/dashboard/${uuid}`);
  };

  return (
    <>
      <ToastBlockContainer
        successToast={successToast}
        showToast={showToast}
        setShowToast={setShowToast}
        toastMessage={toastMessage}
      />
      <div className="page-content">
        {/* Payment modal */}
        <Modal
          show={showAddNewPaymentMethod}
          onHide={() => {
            setShowAddNewPaymentMethod(false);
            setShowPaymentMtd(true);
          }}
          className="payment_modal"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h3>Update the Card</h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-3 subtext">
              Add the details below to update the card
            </p>
            <CheckoutForm
              card={"update"}
              customerId={custId}
              priceId={currentPlanDetails.stripePric}
              paymentList={paymentList}
              planId={currentPlanDetails.id}
              familyName={
                familyDetails.FamilyData
                  ? familyDetails.FamilyData.Family.name
                  : ""
              }
            />
          </Modal.Body>
        </Modal>

        {/* Cancel Payment modal */}
        <Modal
          show={showCancelAccount}
          onHide={handleCloseCancelAccount}
          className="choose_paymentMethod_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h3>Cancel Account Plan</h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-2">
              You have opted to cancel your Group account plan on Elderly Life.
            </div>
            <div className="mb-2">
              Members of your Group will loose access to the data that they have
              created on Elderly Life.
            </div>
            <div className="mb-2">Do you want to continue?</div>
            <div className="d-flex gap-3 align-center my-4">
              <Primary
                children="Cancel"
                size="mediumbtn"
                variant="info"
                type=""
                className="btn btn-white"
                onClick={handleCloseCancelAccount}
              />
              <Primary
                children="Yes"
                size="mediumbtn"
                variant="primary"
                type=""
                className="btn btn-primary"
                onClick={(e) => cancelFamily(e)}
              />
            </div>
          </Modal.Body>
        </Modal>

        {/* cancel reason popup show */}
        <Modal
          show={cancelReason}
          onHide={cancelFamilyHide}
          className="choose_paymentMethod_modal"
          size={"lg"}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h3>Reason for cancellation</h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <textarea
              id="w3review"
              name="w3review"
              style={{
                height: "5rem",
                width: "100%",
                margin: "0.5rem 0 0 0",
                padding: "12px",
              }}
              onChange={textField}
              maxlength="100"
            ></textarea>
            <span style={{ fontSize: "13px", fontWeight: "600" }}>
              * The field is optional
            </span>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Primary
                children="Submit"
                size="mediumbtn"
                variant="primary"
                type=""
                className="btn btn-primary"
                onClick={(e) => cancelFamilySuccessfully(e)}
              />
            </div>
          </Modal.Body>
        </Modal>

        {/* trial account popup show */}
        <Modal
          show={showTrialPopup}
          onHide={handleCloseTrialPopup}
          className="choose_paymentMethod_modal"
          size={"lg"}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h3>Cancel subscription</h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="cancel-plan-txt mb-4">
              <div className="mb-2">
                Is there something that we can do to change your mind?
              </div>
              <div className="">
                How about extending the free trial for another 30 days?
              </div>
            </div>
            {/* <div className="cancel-plan-content">
              Members of your Family will loose access to the data that they
              have created on Elderly Life.
            </div> */}
            {/* <p>Do you want to continue?</p> */}
            <div className="cancel-account-btns align-center d-flex align-items-center gap-3">
              <Primary
                children="Please cancel the subscription"
                size="mediumbtn"
                variant="info"
                type=""
                className="btn btn-white"
                onClick={(e) => cancelFamily(e)}
              />
              <Primary
                children=" I would like to extend Free trial"
                size="mediumbtn"
                variant="primary"
                type=""
                className="btn btn-primary"
                onClick={(e) => cancelFamilyTrial(e)}
              />
            </div>
          </Modal.Body>
        </Modal>

        {/* cancelled family modal popup */}
        {!currentPlanLoader && trialCheck.status === "canceled" && (
          <div>
            <Modal
              show={true}
              // onHide={handleCloseModal}
              className="choose_plan_modal"
            >
              <Modal.Header>
                <Modal.Title>
                  <h3>Subscription Cancelled</h3>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="mb-3">
                  You have opted for Subscription Cancellation on{" "}
                  <b>{canceledDate}</b>. So you can't change the plan.
                </div>
                <div className="mb-3">
                  But you can still access your subscription until{" "}
                  <b> {cancelDate}</b>
                </div>
                <div className="btn btn-primary" onClick={backToFD}>
                  Back to Group Dashboard
                </div>
              </Modal.Body>
            </Modal>
          </div>
        )}

        <Container fluid>
          {/* toast */}
          <ToastBlockContainer
            successToast={successToast}
            showToast={showToast}
            setShowToast={setShowToast}
            toastMessage={toastMessage}
          />

          <Row className="justify-content-center gy-0 mb-6rem">
            <Col md="24" lg="20" xl="20" xxl="20">
              <h3 className="p-0 mb-3">Manage Subscription</h3>

              <section className="bg-white p-4 p-md-5 p-lg-6 shadow rounded-4 mb-4 mb-md-6">
                {/* your plan  */}
                <div className="p-0">
                  <h3 className="mb-4">Your plan</h3>

                  <AccountPlanCard
                    uuid={uuid}
                    cardDetails={currentPlanDetails}
                    currentPlanLoader={currentPlanLoader}
                    trialCheck={trialCheck}
                    handleChildData={handleChildData}
                  />
                </div>

                {/* Payment Method  */}
                <div className="pt-5">
                  <h3 className="mb-4">Payment Method</h3>
                  <PaymentMtdCard
                    setShowAddNewPaymentMethod={setShowAddNewPaymentMethod}
                    paymentMethodLoading={paymentMethodLoading}
                    activePaymentMethod={activePaymentMethod}
                  />
                </div>

                {/* Renewal History  */}
                <div className="pt-5">
                  <h3 className="mb-2">Renewal History</h3>
                  <p className="sub-text mb-3">
                    You can view your account plan renewal history.
                  </p>
                </div>

                <div className="p-0">
                  <Col>
                    <Dropdown
                      onSelect={handleYearSelect}
                      className="profile-dropdwn"
                    >
                      <Dropdown.Toggle
                        id="year-by"
                        className="bg-white border border-dark"
                      >
                        {selectedYear}
                        <span className="ms-2">
                          {/* Using Bootstrap caret icon */}
                          <i className="fa fa-caret-down"></i>
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          boxShadow: "rgba(0, 123, 255, 0.2) 0px 3px 8px",
                        }}
                      >
                        {yearsList.map((item, index) => (
                          <Dropdown.Item key={index} eventKey={item.value}>
                            {item.value}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                </div>

                {/* {invoiceList.length > 0 && !invoiceListingLoader && ( */}
                <div className="p-0">
                  <Col className="text-left">
                    <p className="mt-3 mb-0 medium-text  bold">
                      You are viewing the renewal history for the year{" "}
                      {selectedYear}
                    </p>
                  </Col>
                </div>
                {/* )} */}

                {invoiceListingLoader && (
                  <div>
                    <Col md="12" lg="12" className="mt-4 pt-4 text-center">
                      <button className="btn loading-btn" type="button">
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                        Loading Invoices . . .
                      </button>
                    </Col>
                  </div>
                )}
                {invoiceList.length > 0 && !invoiceListingLoader && (
                  <div className="mt-5">
                    <Row class="gx-3 gy-0">
                      <Col xs="9" md="12" lg="14" xl="14" xxl="14">
                        <span class=" fw-semibold">Payment Date</span>
                      </Col>
                      <Col xs="6" md="5" lg="4" xl="4" xxl="4">
                        <span class=" fw-semibold">Amount</span>
                      </Col>
                      <Col xs="9" md="7" lg="6" xl="6" xxl="6">
                        <span class=" fw-semibold">Invoice Number</span>
                      </Col>
                    </Row>
                    {invoiceList.map(
                      (invoice, index) =>
                        invoice.currYear === newYear && (
                          <div key={index}>
                            <RenewalHistoryCard invoice={invoice} />
                          </div>
                        )
                    )}
                  </div>
                )}
                {checkYear === "checkYear" && !invoiceListingLoader && (
                  <div>
                    <div className="renewal-history-card mb-4 mt-4">
                      <div className="noData">No Data Found...</div>
                    </div>
                  </div>
                )}
              </section>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
export default ManageSubscription;
